import styles from "../static/loader/styles.scss";
import LoaderHtml from "../static/loader/index.html";
import { LoaderProperties } from "../models/loader.models";
import { Helper } from "../helpers/helper";

/**
 * LoaderUtility injects and removes a loading spinner overlay within a page container.
 */
export class LoaderUtility {
    private static readonly UNIQUE_ID: string = "VAIMISUtility_Loader";

    /**
     * Creates and appends a loader overlay to a parent element, lazily injecting the loader's stylesheet, positioning the parent relatively if it is statically positioned so the overlay can be absolutely positioned within it, and applying text, sizing, opacity, and full-height/fixed display options.
     * @param loaderProperties Display options for the loader, such as text, sizing, opacity, and whether it should be full-page or fixed height (defaults applied via {@link LoaderProperties})
     * @param parentSelector Selector or element the loader overlay should be appended to (defaults to `document.body`)
     * @returns The generated unique id assigned to the loader element, which can be passed to {@link removeLoader} to remove it later
     */
    public static addLoader(loaderProperties: LoaderProperties = {}, parentSelector: any = document.body): string {
        // lazily include style tag when loader added
        styles.use();

        let properties: LoaderProperties = Object.assign(new LoaderProperties(), loaderProperties);
        let jParent = jQuery(parentSelector);

        let position = jParent.css("position");
        if (position == "static") {
            jParent.css("position", "relative");
        }

        let loaderId = this.UNIQUE_ID + "_" + Date.now();
        let jLoader = jQuery(LoaderHtml);
        jLoader.attr("id", loaderId);

        // applying properties
        let jLoaderText = jLoader.find(".va-imis-utility-loader-text");
        let jLoaderIcon = jLoader.find(".va-imis-utility-loader-icon");

        jLoaderText.text(properties.loaderText).css("font-size", properties.fontSize);
        jLoaderIcon.css({
            width: properties.width,
            height: properties.height
        });

        if (properties.isOpaque) {
            jLoader.css("background-color", "white");
            jLoaderText.css("color", "black");
        }

        if (properties.isFull) {
            jLoader.css({
                height: "100vh",
                position: "fixed"
            });
        } else if (!Helper.isStringNullOrEmpty(properties.containerHeight)) {
            jLoader.css("height", properties.containerHeight);

            // the following configuration depends on the above one to work properly
            if (properties.isPositionStatic) {
                jLoader.css("position", "static");
            }
        }

        jParent.append(jLoader);
        return loaderId;
    }

    /**
     * Removes a previously added loader overlay from the DOM.
     * @param loaderId The unique id of the loader element, as returned by {@link addLoader}
     */
    public static removeLoader(loaderId: string) {
        let jLoader = jQuery("#" + loaderId);
        jLoader.remove();
    }
}